export enum BaselineResultType {
    NEW     = 0,
    AHEAD   = 1,
    ON_TIME = 2,
    BEHIND  = 3,
}